import { ThemeConfig, theme } from 'antd';

// Shared tokens for both themes
const sharedTokens = {
  // Font
  fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif",
  fontSize: 14,
  fontSizeHeading1: 38,
  fontSizeHeading2: 30,
  fontSizeHeading3: 24,
  fontSizeHeading4: 20,
  fontSizeHeading5: 16,
  
  // Border radius
  borderRadius: 8,
  borderRadiusLG: 12,
  borderRadiusSM: 6,
  
  // Spacing
  padding: 16,
  paddingLG: 24,
  paddingSM: 12,
  paddingXS: 8,
  
  // Height
  controlHeight: 40,
  controlHeightLG: 48,
  controlHeightSM: 32,
};

// Light theme
export const CitadeloLightTheme: ThemeConfig = {
  token: {
    ...sharedTokens,
    // Primary colors
    colorPrimary: '#1a1a2e',
    colorSuccess: '#28a745',
    colorWarning: '#ffc107',
    colorError: '#dc3545',
    colorInfo: '#17a2b8',
    
    // Background colors
    colorBgBase: '#f8f9fa',
    colorBgContainer: '#ffffff',
    colorBgElevated: '#ffffff',
    
    // Text colors
    colorTextBase: '#2c3e50',
    colorTextSecondary: '#6c757d',
    
    // Border colors
    colorBorder: '#e9ecef',
    colorBorderSecondary: '#f1f3f4',
    
    // Box shadow
    boxShadow: '0 2px 8px rgba(26, 26, 46, 0.1)',
    boxShadowSecondary: '0 1px 4px rgba(26, 26, 46, 0.08)',
  },
  components: {
    Button: {
      colorPrimary: '#1a1a2e',
      borderRadius: 8,
      fontWeight: 500,
    },
    Input: {
      borderRadius: 8,
      colorBorder: '#e9ecef',
      colorPrimary: '#1a1a2e',
    },
    Card: {
      borderRadius: 12,
      boxShadow: '0 2px 8px rgba(26, 26, 46, 0.1)',
      colorBgContainer: '#ffffff',
    },
    Typography: {
      colorTextHeading: '#1a1a2e',
      colorText: '#2c3e50',
    },
    Layout: {
      bodyBg: '#f8f9fa',
      colorBgContainer: '#ffffff',
    },
    Menu: {
      colorBgContainer: '#ffffff',
      colorItemBg: 'transparent',
      colorItemBgHover: '#f8f9fa',
      colorItemBgSelected: '#1a1a2e',
      colorItemTextSelected: '#ffffff',
      colorItemText: '#2c3e50',
    },
    Table: {
      colorBgContainer: '#ffffff',
      colorTextHeading: '#1a1a2e',
    },
    Form: {
      labelColor: '#1a1a2e',
      colorText: '#2c3e50',
    },
    Alert: {
      borderRadius: 8,
    },
  },
};

// Dark theme
export const CitadeloDarkTheme: ThemeConfig = {
  algorithm: theme.darkAlgorithm,
  token: {
    ...sharedTokens,
    // Primary colors
    colorPrimary: '#4f8cff',
    colorSuccess: '#52c41a',
    colorWarning: '#faad14',
    colorError: '#ff4d4f',
    colorInfo: '#1890ff',
    
    // Background colors
    colorBgBase: '#141414',
    colorBgContainer: '#1f1f1f',
    colorBgElevated: '#262626',
    
    // Text colors
    colorTextBase: '#e6e6e6',
    colorTextSecondary: '#a6a6a6',
    
    // Border colors
    colorBorder: '#424242',
    colorBorderSecondary: '#303030',
    
    // Box shadow
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.45)',
    boxShadowSecondary: '0 1px 4px rgba(0, 0, 0, 0.35)',
  },
  components: {
    Button: {
      colorPrimary: '#4f8cff',
      borderRadius: 8,
      fontWeight: 500,
    },
    Input: {
      borderRadius: 8,
      colorBorder: '#424242',
      colorPrimary: '#4f8cff',
    },
    Card: {
      borderRadius: 12,
      boxShadow: '0 2px 8px rgba(0, 0, 0, 0.45)',
      colorBgContainer: '#1f1f1f',
    },
    Typography: {
      colorTextHeading: '#ffffff',
      colorText: '#e6e6e6',
    },
    Layout: {
      bodyBg: '#141414',
      colorBgContainer: '#1f1f1f',
    },
    Menu: {
      colorBgContainer: '#1f1f1f',
      colorItemBg: 'transparent',
      colorItemBgHover: '#262626',
      colorItemBgSelected: '#4f8cff',
      colorItemTextSelected: '#ffffff',
      colorItemText: '#e6e6e6',
    },
    Table: {
      colorBgContainer: '#1f1f1f',
      colorTextHeading: '#ffffff',
    },
    Form: {
      labelColor: '#ffffff',
      colorText: '#e6e6e6',
    },
    Alert: {
      borderRadius: 8,
    },
  },
};

// Default export for backwards compatibility
export const CitadeloTheme = CitadeloLightTheme;
export default CitadeloTheme;
